export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";